(function () {
    'use strict';

    angular
        .module('app.filterTypes')
        .controller('FilterTypesListController', FilterTypesListController);

    FilterTypesListController.$inject = ['common', 'dataservice', 'bootstrap.dialog', 'config', '$state'];
    /* @ngInject */
    function FilterTypesListController(common, dataservice, bsDialog, config, $state) {
        var vm = this;

        vm.title = 'Filter Types';
        vm.displayedItems = [];
        vm.items = [];
        vm.counts = [];
        vm.refresh = refresh;
        vm.usersWithFilterType = usersWithFilterType;
        vm.copy = copy;

        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItems(), getCounts()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
            }, function (error) { });
        }

        function usersWithFilterType(filterTypeId) {
            for (var i = 0; i < vm.counts.length; i++) {
                if (vm.counts[i].Name == filterTypeId) {
                    return vm.counts[i].ActiveCount;
                }
            }
        }

        function getCounts() {
            return dataservice.getItems('api/FilterTypes/CountsOfUsersWithFilterType/-1').then(function (response) {
                vm.counts = response.data;
                return vm.counts;
            }, function (error) { });
        }

        function getItems() {
            return dataservice.getItems('api/FilterTypes').then(function (response) {
                vm.items = response.data;
                vm.displayedItems = [].concat(vm.items);
                return vm.items;
            }, function (error) { });
        }

        function refresh() {
            getItems();
        }

        function copy(id) {
            var dto = {
                data: id
            };
            return dataservice.saveItem('api/FilterTypes/Copy', dto).then(function (response) {
                var newId = response.data.Message;
                $state.transitionTo('filtertypes.details', { id: newId });


            }, function (error) { });
        }
    }
})();
